import { DescendantsVariantContext } from '../../contexts/descendants-variant-context/descendants-variant-context';

export const DescendantsVariantProvider = DescendantsVariantContext.Provider;
